import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Div } from '@driftt/tide-core'
import List from './List'

import './NewTabs.css'

const mapStateToProps = state => {
  return {
    contactTags: state.__CRM.filterBuilder.tags
  }
}

class ContactTags extends Component {
  constructor(props) {
    super(props)

    this.state = {
      tags: null
    }
  }

  componentDidMount() {
    this.formatData()
  }

  formatData = () => {
    const { contactTags } = this.props

    this.setState({
      tags: [{
        title: 'Tags',
        properties: contactTags
      }]
    })
  }

  render() {
    const { onSelectProp } = this.props
    const { tags } = this.state
    return (
      <Div className="contact-properties--container">
        <Div className="filter-builder--tabs">
          {!!tags && 
            <List 
              displayKey="displayName" 
              filterKey="name" 
              onSelect={onSelectProp} 
              helpText={'Tags are labels added to a contact'}
              title={'Contact Tags'}
              properties={tags}
              hideType={true}
              subEntityType={'tags'}
          />
        }
        </Div>
      </Div>
    )
  }
}

export default connect(mapStateToProps)(ContactTags)
